import { ScoreExplanationProps } from "@/api/useTriage.types"
import { InformationPopover } from "@/molecules/InformationPopover"
import { ScoreExplanation } from "@/molecules/ScoreExplanation"
import { KodemScore } from "./KodemScore"
import { TitleKodemScore } from "./TitleKodemScore"

import styles from "./KodemScoreCell.module.scss"

import type { TFunction } from "@/hooks/useTranslation"

const KodemScoreCellComponent = (
  score: number,
  popoverComponent: React.ReactNode,
  title: string | React.ReactNode,
  t: TFunction
) => (
  <InformationPopover.Popover
    placement="top"
    classNamePopover={styles.popover}
    content={
      <InformationPopover.CommonTemplate title={title}>
        <div className={styles.column}>
          <span className={styles.scoreBreakdown}>
            {t("triage.drawer.kodemScoreBreakdown")}
          </span>
          {popoverComponent}
        </div>
      </InformationPopover.CommonTemplate>
    }
  >
    <span>
      <KodemScore underline score={score} />
    </span>
  </InformationPopover.Popover>
)

export const KodemScoreIssueCell =
  (t: TFunction) => (_score: number, props: ScoreExplanationProps) =>
    KodemScoreCellComponent(
      props.kodemScore,
      <ScoreExplanation record={props} bordered={false} />,
      <TitleKodemScore score={_score} />,
      t
    )
